export default import.meta.ROLLUP_FILE_URL_koi$5ne0$Yk3nzbaZNr3SA